module.exports = __webpack_public_path__ + "static/backgroundMesh-d447d93011fee4ee9e48e10d589be57d.png";